import { render, staticRenderFns } from "./livePriceUphold.vue?vue&type=template&id=0b959b4a&scoped=true&"
import script from "./livePriceUphold.vue?vue&type=script&lang=js&"
export * from "./livePriceUphold.vue?vue&type=script&lang=js&"
import style0 from "./livePriceUphold.vue?vue&type=style&index=0&id=0b959b4a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b959b4a",
  null
  
)

export default component.exports